import useSwr from 'swr'
import { API_URL } from '@/utils/constants'
import Wallet from '@/utils/wallet'

const localFetcher = (...args: any[]) => {
	if (args[0].includes('null')) {
		return { data: {}, isLoading: false }
	}

	return fetch(args[0], {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' }
	}).then(res => res.json())
}

export default function useWalletHistory(address?: string) {
	return useSwr(`${API_URL}/wallet/${address || Wallet.getTaprootAddress()}/history`, localFetcher)
}
